var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#148BE9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.892 1.375c1.605 1.593 1.455 3.663-.39 5.507L9.936 8.449c.176-.664.05-1.881-.213-2.22l.54-.526c1.128-1.104 1.266-2.283.413-3.124-.865-.853-1.982-.69-3.136.427L6.436 4.097C5.294 5.213 5.169 6.355 6.034 7.22c.226.213.69.565.89.665-.112.351-.601 1.016-1.053 1.367-.288-.188-.727-.527-1.04-.828C3.198 6.87 3.3 4.737 5.193 2.918l1.191-1.166c1.87-1.807 3.889-1.995 5.507-.377z",
    transform: "translate(-512 -602) translate(0 592) translate(502) translate(10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.117 12.475C-.476 10.87-.338 8.8 1.507 6.97l1.58-1.58c-.176.677-.05 1.88.2 2.232l-.527.514c-1.128 1.104-1.279 2.283-.413 3.136.865.84 1.981.677 3.123-.439l1.116-1.091c1.129-1.117 1.254-2.245.401-3.111-.225-.226-.69-.564-.89-.677.1-.351.602-1.016 1.054-1.367.288.2.714.539 1.04.84 1.631 1.555 1.518 3.688-.363 5.506l-1.192 1.154c-1.881 1.806-3.9 2.007-5.519.39z",
    transform: "translate(-512 -602) translate(0 592) translate(502) translate(10 10)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.0e8e8822112ba947822a97827c2370fc.svg";
export { ForwardRef as ReactComponent };